import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { Select, SelectedItems } from '@backstage/core-components';
import { C4DiagramEntity } from '../C4DiagramCard/types';

interface DialogDependencyProps {
  open: boolean;
  relations: Array<C4DiagramEntity>;
  onClose: () => void;
  onSave: (id: string, description: string) => void;
}

export function DialogDependency({
  open,
  relations,
  onClose,
  onSave,
}: Readonly<DialogDependencyProps>) {
  const allRelations = relations.map(it => {
    return { label: `${it.type}: ${it.text}`, value: it.id };
  });
  const [relation, setRelation] = useState<SelectedItems>('');
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    setRelation(relations && relations.length > 0 ? relations[0].id : '');
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Dependency</DialogTitle>
      <DialogContent>
        <Select
          label="Depends on"
          items={allRelations}
          onChange={(e: SelectedItems) => {
            setRelation(e);
          }}
          multiple={false}
          selected={relation}
        ></Select>
        <TextField
          label="Description"
          fullWidth
          multiline={true}
          onChange={(e: any) => {
            setDescription(e.target.value);
          }}
        ></TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onSave(relation as string, description)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
